module.exports = __webpack_public_path__ + "static/mercado-libre-0e02d53b65fff713272d7cac43e843ee.jpg";